import ValueWithPreservePrecision from './ValueWithPreservePrecision';

export default ValueWithPreservePrecision;
